import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=6280c221&scoped=true"
var script = {}
import style0 from "./PageForbidden.vue?vue&type=style&index=0&id=6280c221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280c221",
  null
  
)

export default component.exports